/**
 * A library object is rendered as a card in list or as a header (when it's a current parent).
 */
export default class LibraryObjectViewType {
  static LIST = "list";
  static HEADER = "header";
  static FOLDER = "folder";
}
